import React, { Component } from 'react'
import styled from 'styled-components'
import Button from '../Button'

export default class Modal extends Component {
  render() {
    const {
      visible,
      onOk,
      onCancel,
      title,
      width,
      content,
      children,
      footer,
      okText,
      cancelText,
    } = this.props
    if (!visible) {
      return null
    }
    return (
      <>
        <Background data-testid="modalBackground" onClick={onCancel} />
        <Container data-testid="modalContainer" width={width}>
          <Title data-testid="modalTitle">{title}</Title>
          <Content data-testid="modalContent">{content || children}</Content>
          <Footer>
            {footer || (
              <>
                <Button onClick={onCancel} data-testid="cancelModal">
                  {cancelText || '取消'}
                </Button>
                <Button onClick={onOk} data-testid="confirmModal">
                  {okText || '确定'}
                </Button>
              </>
            )}
          </Footer>
        </Container>
      </>
    )
  }
}

const Title = styled.h2`
  padding: 0 20px 20px;
  border-bottom: 1px solid gray;
`
const Footer = styled.div`
  padding: 20px 20px;
  border-top: 1px solid gray;
  text-align: right;
`
const Background = styled.div`
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 2;
  background-color: rgba(0, 0, 0, 0.6);
`
const Container = styled.div`
  position: fixed;
  background-color: #fff;
  width: ${({ width }) => (width ? `${width}px` : '520px')};
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 10;
`
const Content = styled.div`
  padding: 20px;
  background-color: #fff;
`
